import {
  fallbackCategories,
  fallbackTags,
} from "../fallback/contentFallbacks";
import { mapWordPressTerm } from "../mappers/wordpressMappers";
import { createServiceResult } from "./serviceResult";
import { fetchCategories, fetchTags } from "../wordpress/wordpressApi";

export async function getCategories(options = {}) {
  try {
    const response = await fetchCategories(options);

    return createServiceResult({
      data: response.data.map(mapWordPressTerm),
      source: "api",
    });
  } catch (error) {
    return createServiceResult({
      data: fallbackCategories,
      source: "fallback",
      error,
      usedFallback: true,
    });
  }
}

export async function getTags(options = {}) {
  try {
    const response = await fetchTags(options);

    return createServiceResult({
      data: response.data.map(mapWordPressTerm),
      source: "api",
    });
  } catch (error) {
    return createServiceResult({
      data: fallbackTags,
      source: "fallback",
      error,
      usedFallback: true,
    });
  }
}
